import { css, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { Style } from "../Styles";
import { IPlaceReport, makeEmptyPlaceReport } from "../../models/Models";
import { LightTheme } from "../ThemeLight";
import { Form } from "../form/Form";
import { watch } from "../internal/watch";
import { Fields } from "./PlaceReportEditor.form";
import { cloneDeep } from "lodash-es";
import { IPlaceTable } from "../../backend/IPlaceTable";
import { litIf } from "../LitUtils";

@customElement("ds-place-report-editor")
export class PlaceReportEditor extends Form {
    static override styles = [
        Style,
        LightTheme,
        css`
            :host {
                display: block;
            }

            .container {
                width: 100%;
                color: black;
            }

            h2 {
                align-self: center;
            }

            .editor-label {
                font-weight: bold;
                color: black;
            }
        `,
    ];
    @property({ type: Object }) report: IPlaceReport = makeEmptyPlaceReport();
    @property({ type: String }) placeId?: string;
    @property({ type: Boolean }) tidal = false;

    @state() protected _saving = false;

    private _placeTable = this._kernel.dataStore.getSource<IPlaceTable>("places");

    @watch("report")
    onReportChanged() {
        this._object = this.report;
    }

    @watch("tidal")
    onTidalChanged() {
        this.visibleFields = [];
        if (this.tidal) {
            this.visibleFields.push("tidal");
        }
    }

    private async _save() {
        try {
            const userId = this._kernel.user?.id;
            if (userId) {
                const report = cloneDeep(this.report) as IPlaceReport;
                report.date = new Date().toISOString();
                report.owner = userId;
                let saved = false;
                this._saving = true;
                if (report.id === undefined || report.id.length === 0) {
                    if (this.placeId) {
                        this.report = await this._placeTable.createReport(this.placeId, report);
                        saved = true;
                    }
                } else {
                    const updated = await this._placeTable.updateReport(report);
                    if (updated) {
                        this.report = updated;
                        saved = true;
                    }
                }
                if (saved) {
                    this._raiseEvent("ds-accept", { report: this.report });
                }
            }
        } finally {
            this._saving = false;
        }
    }

    override render() {
        return html`<div class="container flex-column">
            ${litIf(
                this._saving,
                () => html`<ds-progress-spinner></ds-progress-spinner>`,
                () =>
                    html` ${this._renderForm(Fields)}
                        <div class="button-row">
                            <sl-button @click=${() => this._raiseEvent("ds-cancel")}
                                >Cancel</sl-button
                            >
                            <sl-button variant="success" @click=${() => this._save()}
                                >${this.report.id.length > 0 ? "Save" : "Submit"}</sl-button
                            >
                        </div>`
            )}
        </div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-place-report-editor": PlaceReportEditor;
    }
}
